import axios from 'axios';

export interface UpdateAlmanacAgentUserSubscriptionBody {
  buyerShowingCalendarSubscription: boolean;
  listingShowingCalendarSubscription: boolean;
  showBuyerShowingsAsBusy: boolean;
  showListingShowingsAsBusy: boolean;
}

const updateAlmanacAgentUserSubscription = async (
  body: UpdateAlmanacAgentUserSubscriptionBody,
) => {
  const config = {
    url: `/almanac/agent_subscription`,
    method: 'post' as const,
    data: body,
  };

  await axios.request(config);
};

export default updateAlmanacAgentUserSubscription;
